var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 13231",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 16 - \\uC724\\uACFD\\uC120",
    d: "M5.913 12.809a.788.788 0 0 1-.561-.232l-5.62-5.62a.794.794 0 0 1 0-1.122.788.788 0 0 1 .561-.235.788.788 0 0 1 .561.232l4.284 4.288V.293a.793.793 0 1 1 1.586 0v9.789l4.246-4.246a.793.793 0 1 1 1.122 1.122l-5.619 5.619a.788.788 0 0 1-.56.232z",
    transform: "translate(1.899 1.084)",
    style: {
      fill: "#4493f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 2 - \\uC724\\uACFD\\uC120",
    d: "M10.488-1.914H-2.707a.794.794 0 0 1-.793-.793.794.794 0 0 1 .793-.793h13.195a.794.794 0 0 1 .793.793.794.794 0 0 1-.793.793z",
    transform: "translate(3.997 16.804)",
    style: {
      fill: "#4493f9"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic_download.08f53918eb8f987c95dd66c74ee9da11.svg";
export { ForwardRef as ReactComponent };